<!--begin::Signin-->
<div class="lum-auth" [ngClass]="{ 'body-logged-in': loggedIn }">
  <div class="kt-grid__item kt-grid__item--middle">
    <div class="kt-login__logo">
      <img
        alt="Luminous Logo"
        src="./assets/logo/png/luminous-horiz-rgb-fullcolor-small.png"
        srcset="./assets/logo/svg/luminous-horiz-rgb-fullcolor.svg"
      />
    </div>
  </div>
  <div class="lum-auth-title">
    <h3 [translate]="'AUTH.LOGIN.TITLE'">Team Login</h3>
  </div>

  <!-- <kt-auth-notice></kt-auth-notice> -->

  <!--begin::Form-->
  <form
    class="lum-auth-form"
    [formGroup]="loginForm"
    (submit)="handleSubmit($event)"
  >
    <div class="form-group lum-auth-form-group">
      <input
        type="email"
        placeholder="Email"
        formControlName="email"
        maxlength="100"
        class="lum-input lum-input--primary lum-auth-input"
        [ngClass]="{
          'lum-auth-input--has-error':
            isControlHasError('email', 'required') ||
            isControlHasError('email', 'email') ||
            isControlHasError('email', 'maxLength'),
        }"
        [translate]="'FORM.INPUT.EMAIL'"
      />
      <div class="lum-auth-input-error">
        <mat-error *ngIf="isControlHasError('email', 'required')">
          <strong
            [translate]="'FORM.VALIDATION.REQUIRED'"
            [translateParams]="{ name: 'FORM.INPUT.EMAIL' | translate }"
          >
            Email is required.</strong
          >
        </mat-error>
        <mat-error *ngIf="isControlHasError('email', 'email')">
          <strong
            [translate]="'FORM.VALIDATION.INVALID'"
            [translateParams]="{ name: 'FORM.INPUT.EMAIL' | translate }"
          >
            Invalid email value.</strong
          >
        </mat-error>
        <mat-error *ngIf="isControlHasError('email', 'maxLength')">
          <strong
            [translate]="'FORM.VALIDATION.MAX_LENGTH'"
            [translateParams]="{ max: 100, name: 'FORM.INPUT.EMAIL' | translate }"
          >
            Should not exceed 100 characters.</strong
          >
        </mat-error>
      </div>
    </div>
    <div class="form-group lum-auth-form-group">
      <input
        type="password"
        placeholder="Password"
        formControlName="password"
        autocomplete="off"
        class="lum-input lum-input--primary lum-auth-input"
        [ngClass]="{
          'lum-auth-input--has-error': isControlHasError('password', 'required'),
        }"
        [translate]="'FORM.INPUT.PASSWORD'"
      />
      <div class="lum-auth-input-error">
        <mat-error *ngIf="isControlHasError('password', 'required')">
          <strong
            [translate]="'FORM.VALIDATION.REQUIRED'"
            [translateParams]="{ name: 'FORM.INPUT.PASSWORD' | translate }"
          >
            Password is required</strong
          >
        </mat-error>
      </div>
    </div>
    <!--begin::Action-->
    <div class="lum-auth-actions">
      <!-- <span>
        <mat-label [translate]="'FORM.INPUT.LANGUAGE'">Language</mat-label>
        <mat-radio-group aria-labelledby="langauge" class="language-radio-group" formControlName="language">
          <mat-radio-button class="language-radio-button" *ngFor="let lang of languages"
          [value]="lang.lang">
          {{lang.name}}
          </mat-radio-button>
        </mat-radio-group>
      </span> -->

      <button
        type="submit"
        [disabled]="loading"
        id="kt_login_signin_submit"
        class="lum-button lum-button--primary"
        [ngClass]="{
          'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
        }"
        [translate]="'AUTH.LOGIN.BUTTON'"
        >Sign In</button
      >
      <a
        routerLink="/auth/forgot-password"
        class="lum-button lum-button--link"
        [translate]="'AUTH.GENERAL.FORGOT_BUTTON'"
        >Forgot Password</a
      >
    </div>
    <!--end::Action-->
  </form>
  <!--end::Options-->
</div>
<!--end::Signin-->
